const PUBLIC_FIELDS_CONTACT = [
  'phone',
  'email',
  'firstName',
  'lastName',
  'middleName',
  'date',
  'gender',
  ...Array(20)
    .fill('custom')
    .map((v, i) => v + ('' + (i + 1)).padStart(2, '0'))
]

module.exports = {
  PUBLIC_FIELDS_CONTACT
}
